module.exports = __webpack_public_path__ + "img/client1.fa27c6e4.png";